import React, { Fragment, useEffect, useRef, useState } from 'react'
import AddComponent from '../../../components/AddComponent'
import { PencilSquareIcon, TrashIcon } from '@heroicons/react/24/solid'
import LinkButton from '../../helpers/LinkButton'
import Table from '../../helpers/Table'
import Loader from '../../Common/Loader'
import { Link } from 'react-router-dom'
import ActionButton from '../../helpers/ActionButton'
import { useReactToPrint } from 'react-to-print'
import Pagination from '../../helpers/Pagination';
import { AddCircle } from 'iconsax-react'
import DataNotFound from '../../helpers/DataNotFound'
import { DeleteGladianceJobTitle, GetGladianceJobTitleList } from '../../../Encapsulation/GladianceDomainEntities/GladianceJobTitle'
import Swal from 'sweetalert2'
import axiosClient from '../../../Encapsulation/Axios'
import flasher from '@flasher/flasher'

function GladianceJobtitleMaster() {

    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }
    document.title = 'Gladiance - Job Title'
    const tableHeading = ['Sr.No', 'Department Name', 'Job Title', 'Action']
    const [loader, setLoader] = useState(false)
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 7;
    const [gladianceJobTitleList, setGladianceJobTitleList] = useState([]);
    const [errors, setErrors] = useState([])

    const fetchGladianceJobTitleList = async () => {
        setGladianceJobTitleList(await GetGladianceJobTitleList(setErrors));
    }

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    const deleteGladianceJobTitle = (tableData) => {
        Swal.fire({
            title: 'Are you sure to delete this?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                let response = await DeleteGladianceJobTitle(tableData)
                if (response.Successful == false) {
                    flasher.warning(response.Message)
                } else {
                    flasher.success('Deleted Successfully')
                    fetchGladianceJobTitleList();
                }
            }
        })
    }

    useEffect(() => {
        fetchGladianceJobTitleList();
    }, [])

    return (
        <Fragment>
            {loader ? (<Loader />) : (
                <AddComponent title={'Job Titles'} button={
                    <LinkButton to={'/gladiance-job-title-master/add-gladiance-job-title-master'}>
                        <AddCircle variant='Bold' className='w-5 h-5' />
                        <span>Add Job Title</span>
                    </LinkButton>
                }>
                    {gladianceJobTitleList && gladianceJobTitleList.length > 0 ? (
                        <div ref={componentRef} className='m-2'>
                            <Table tableHeading={tableHeading}>
                                {gladianceJobTitleList && gladianceJobTitleList.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((tableData, tableDataID) => {
                                    return (
                                        <Fragment key={tableDataID}>
                                            <tr className="border-b border-opacity-30 border-white text-center ">
                                                <td className="px-4 py-3">{tableDataID + 1}</td>
                                                <td className="px-4 py-3">{tableData.GladianceDepartmentName}</td>
                                                <td className="px-4 py-3">{tableData.Name}</td>
                                                <td className="px-4 py-3">
                                                    <div className='flex justify-center gap-3'>
                                                        <Link to={`/gladiance-job-title-master/edit-gladiance-job-title-master/${tableData.Ref}`} title='Edit' ><ActionButton className={'p-1.5 text-white bg-yellow-400 '}>
                                                            <PencilSquareIcon className='w-4 h-4' />
                                                        </ActionButton></Link>
                                                        <ActionButton onClick={() => deleteGladianceJobTitle(tableData)} title={'Delete'} className='p-1.5 text-white bg-red-600 rounded-lg cursor-pointer'>
                                                            <TrashIcon className='w-4 h-4' />
                                                        </ActionButton>
                                                    </div>
                                                </td>
                                            </tr>
                                        </Fragment>
                                    )
                                })}
                            </Table>
                        </div>

                    ) : (
                        <DataNotFound labelText={'Sorry! Job Titles Data Not Found'} />

                    )}
                    {gladianceJobTitleList && gladianceJobTitleList.length > 7 ? (<div className="flex justify-end">
                        <Pagination
                            itemsPerPage={itemsPerPage}
                            totalItems={gladianceJobTitleList.length}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                        />
                    </div>) : (<div></div>)
                    }

                </AddComponent>
            )}
        </Fragment>
    )
}
export default GladianceJobtitleMaster
